// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import VueRouter from 'vue-router'
import routes from './router'
import * as Cookies from 'js-cookie'
import store from './store'
import i18n from './lang.js'
import axios from './axios.js'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import VueProgressBar from 'vue-progressbar'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueToastr2 from 'vue-toastr-2'
import Mixin from './mixins/index.js'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VModal from 'vue-js-modal'
import VueMaterial from 'vue-material'
import TreeView from 'vue-json-tree-view'
import constant from './utils/constants/constant'
window.$ = require('jquery')

// import * as VueGoogleMaps from 'vue2-google-maps'

Vue.mixin(Mixin)
Vue.use(VueMaterial)
Vue.use(BootstrapVue)
Vue.use(Cookies)
Vue.use(VueRouter)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(VuejsDialog)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
Vue.use(TreeView)

Vue.use(VueProgressBar, {
  autoFinish: false,
  thickness: '4px'
})

Vue.use(VueMoment, {
  moment
})

Vue.prototype.$const = constant

// fix select issue vue-material
Vue.component('MdSelect', Vue.options.components.MdSelect.extend({
  methods: {
    isInvalidValue: function isInvalidValue () {
      return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput
    }
  }
}))

const router = routes
Vue.router = router

Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      let info = JSON.parse(unescape(atob(token)))
      let client_id = localStorage.getItem('clientID')
      if (client_id !== null) {
        client_id = localStorage.getItem('clientID')
      } else {
        if (info.client_ids[0]) {
          client_id = info.client_ids[0]
        }

        if (info.user_id === 1) {
          client_id = '606dd890-1e5d-4898-853a-0ef434fff627'
        }
        else if(info.user_id===5){
          client_id='584a2076-9a82-41d0-b585-d63168dd61b0'
        }
      }
      localStorage.setItem('clientID', client_id)
      this.options.http._setHeaders.call(this, req, {'x-token': info.token, 'Client': client_id})
    },
    response: function (res) {
      if (res.data.data && res.data.data.user && res.data.data.user.roles) {
        let user_info = res.data.data
        let token = user_info.token
        let roles = user_info.user.roles
        let client_ids = user_info.user.clients
        let modules = user_info.user.permissions
        let user_id = user_info.user.id
        let client_id = ''
        if (client_ids[0]) {
          client_id = client_ids[0]
        }

        if (user_id === 1) {
          client_id = '606dd890-1e5d-4898-853a-0ef434fff627'
        }
        else if(user_id==5){
          client_id='584a2076-9a82-41d0-b585-d63168dd61b0'
        }

        localStorage.setItem('clientID', client_id)
        let info = {
          token: token,
          client_ids: client_ids,
          roles: roles,
          modules: modules,
          user_id: user_id,
          user_info: user_info,
          config: {
            "fcds": {
              "host": "https://fcds.phdvasia.com/",
              "deal_detail": "combo-detail/",
              "menu_detail": "order/",
            },
            "banner": {
             "top": ["desktop_thumbnail", "mobile_thumbnail"],
             "left": ["desktop_thumbnail", "mobile_thumbnail"],
             "right": ["desktop_thumbnail", "mobile_thumbnail"]
            },
            "payment_method": [{
              "credit_card_accepted": [
                {
                  "credit_card": [
                    {"name": "active", "default": 1, "type": "radio", "label": "Active"},
                    {"name": "min", "default": 0, "type": "textbox", "label": "mincart"},
                    {"name": "max", "default": 0, "type": "textbox", "label": "Maximum cart value"}
                  ]
                }
              ],
              "ponta_card_accepted": [
                {
                  "pota_card": [
                    {"name": "active", "default": 1, "type": "radio", "label": "Active"},
                    {"name": "min", "default": 0, "type": "textbox", "label": "mincart"},
                    {"name": "max", "default": 0, "type": "textbox", "label": "Maximum cart value"}
                  ]
                }
              ],
              "gourmet_card_accepted": [{
                "gourmet_card": [
                  {"name": "active", "default": 1, "type": "radio", "label": "Active"},
                  {"name": "min", "default": 0, "type": "textbox", "label": "mincart"},
                  {"name": "max", "default": 0, "type": "textbox", "label": "Maximum cart value"}
                ]
              }],
              "cash_accepted": [{
                "cash": [
                  {"name": "active", "default": 1, "type": "radio", "label": "Active"},
                  {"name": "min", "default": 0, "type": "textbox", "label": "mincart"},
                  {"name": "max", "default": 0, "type": "textbox", "label": "Maximum cart value"}
                ]
              }]
            }]
          }
        }
        // this.$session.set('permissions', modules)
        return btoa(escape(JSON.stringify(info)))
      }
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: process.env.prefix_tenant + '/login-otp',
    method: 'POST',
    redirect: '/',
    fetchUser: false
  },
  logoutData: {
    url: process.env.prefix_tenant + '/logout',
    method: 'PUT'
  },
  fetchData: {
    enabled: false,
    success: function () {
      let info = Vue.auth.token()
      info = JSON.parse(unescape(atob(info)))
      Vue.auth.user(info)
    }
  },
  refreshData: {
    enabled: false
  },
  notFoundRedirect: {
    path: '/pages/404'
  },
  forbiddenRedirect: {
    path: '/pages/500'
  },
  authRedirect: {
    path: '/login'
  }
})

window.toastr = require('toastr')
Vue.use(VueToastr2)
// Vue event bus
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})
Vue.config.productionTip = false
/* eslint-disable no-new */
const main = new Vue({
  i18n,
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  beforeCreate: function () {
    this.$store.commit('setConfig', this.$session.get('config') || {
      base: {},
      country_code: '',
      main: {},
      gms: {}
    })
    if (this.$auth.check()) {
      const lang = this.$session.get('lang')
      const config = this.$session.get('config')
      const manualConfig = this._.get(config, 'manual_config', {}) || {}

      Vue.axios.defaults.headers.common['Lang'] = lang

      if (lang == 'en' && config != null && config.base != null && config.base.id != null) {
        this.$i18n.locale = lang + '_' + config.base.id
      } else {
        this.$i18n.locale = lang
      }
    } else {
      Vue.axios.defaults.headers.common['Lang'] = 'en'
      this.$i18n.locale = 'en'
    }
  },
  created: function () {
  }
})

export default main



// WEBPACK FOOTER //
// ./src/main.js